import React, { useContext } from 'react'
import './FailedToDownload.scss'
import { WorkspaceContext } from './WorkspaceContext';


const FailedToDownload = () => {
    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");
    const { setDownloadFileErrorPopup } = ctx;
    return (
        <div className='failed-to-download-popup'>
            <div className='popup-header'>
                <h2>Failed to Download</h2>

                <button className='ns-cancel' onClick={() => setDownloadFileErrorPopup(false)}>
                    <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>
                </button>
            </div>

            <p>There was an error downloading the file.</p>
            <p>This could have been due to several reasons such as chrome security settings, network issues, anti-virus software, and browser compatibility.</p>

            <span>Click below to trouble shoot</span>

            <a href="https://flash-room.com/downloadhelp" target="_blank" rel="noopener noreferrer">
                <button className='trouble-shoot-button'>Trouble Shoot</button>
            </a>


        </div>
    )
}

export default FailedToDownload
